import type { FuncOverrideComponent } from '../theme.types';

export const MuiDialogActions: FuncOverrideComponent<'MuiDialogActions'> = theme => ({
  styleOverrides: {
    root: {
      padding: theme.spacing(3),
    },
  },
});
